import type { PriceLevel } from '@bilmat/shared';

/** "75 min" / "1 h" / "1 h 15 min". */
export function formatMinutes(mins: number): string {
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  if (h === 0) return `${m} min`;
  if (m === 0) return `${h} h`;
  return `${h} h ${m} min`;
}

/** Sekunder → "5 h 9 min". */
export function formatDuration(seconds: number): string {
  return formatMinutes(Math.round(seconds / 60));
}

/** Klockslag ur ett Date → "12:34" (24h). */
export function formatClock(date: Date): string {
  const hh = String(date.getHours()).padStart(2, '0');
  const mm = String(date.getMinutes()).padStart(2, '0');
  return `${hh}:${mm}`;
}

/** Framkomst-klockslag: nu + minuter in i resan → "12:34" (24h). */
export function formatArrivalClock(minutesFromNow: number, now: Date = new Date()): string {
  return formatClock(new Date(now.getTime() + minutesFromNow * 60_000));
}

/** Prisnivå → symboler enligt prototypen; null/0 → tom sträng. */
export function priceLabel(level: PriceLevel | null | undefined): string {
  if (level === null || level === undefined || level === 0) return '';
  return '€'.repeat(level);
}

/** Första kända Google-typen → svensk etikett; fallback "Restaurang". */
export function primaryType(types: string[]): string {
  const map: Record<string, string> = {
    restaurant: 'Restaurang',
    cafe: 'Café',
    bakery: 'Bageri',
    bar: 'Bar',
    meal_takeaway: 'Avhämtning',
  };
  for (const t of types) {
    const label = map[t];
    if (label) return label;
  }
  return 'Restaurang';
}
